import React, { useEffect, useRef, useState } from 'react';
import { SearchableSelect } from '../../../../Common/Class/Select/SearchableSelec2';
import { Modal } from '../../../../Common/fModal/Modal';
import { showToast } from '../../../../Common/fToast/ToastCallback';
import { LineHeader } from '../../../../Header/LineHeader';
import { useSelector } from 'react-redux';
import { FunctionalInput } from '../../../../Common/fInputs';
import { PageLoader } from '../../../../Common/Components/PageLoader';
import useTdsList from './useTdsList';

const TdsLineItem = (props) => {

    const [tds,setTds] = useState([]);
    const [tdsMode,setTdsMode] = useState('percentage');
    const [changeTds,setChangeTds] = useState(false);
	const [tdsShown,setTdsShown] = useState(() => {
		if (props.value) {
		  return {
			des: props.value.tdsDesc,
			label: props.value.tdsCode,
			tax: props.value.tdsRate,
		  };
		}
		return undefined;
	});
	const [selectedTds, setSelectedTds] = useState(() => {
		if (props.value) {
		  return {
			id:props.value && props.value.tdsId?props.value.tdsId:null,
			des: props.value.tdsDesc,
			label: props.value.tdsCode,
			tax: props.value.tdsRate,
		  };
		}
		return undefined;
	  });
	  
    const Amount = useRef(),CODE=useRef();
	const TDS_SLAB =useRef()
    const {
		tdsAtLineItemAutomationV2,
        tdsAtLineItemAutomation
	} = useSelector((state) => state.auth.config.plugins);

	let {vendorId,vendor} =props

	const {tdsList:allTds,loader} = useTdsList({
		vendorId,
		vendor,
		tdsSlabs: props.tdsSlabs,
		entityId: props.entityId
	})

	useEffect(()=>{
		setTds(allTds)
	},[allTds])


	useEffect(()=>{
		if(TDS_SLAB && TDS_SLAB.current && selectedTds && !tdsAtLineItemAutomationV2 && !tdsAtLineItemAutomation){
			TDS_SLAB.current.value = selectedTds.tax||0;
		}
	},[selectedTds])

	if(loader){
		return <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
			<PageLoader />
			<p style={{fontWeight:'bold'}}>TDS Sections are being fetched</p>
		</div>
	}
	

    return(
        <>      
                <div style={{}}>
                    <p style={{marginBottom:10}} className='floating-top-label' >Tds</p>
                    <div style ={{
                        height:40,
                        background:'var(--off-white)',
                        border:'1px solid var(--border-color)',
                        width:'100%',
                        padding:5,
                        fontSize:12,
                        color:'var(--text-color)'
                    }} onClick={()=>{
						if(props.disabled) return;
                        setChangeTds(true);
                    }}>
                        {(!tdsShown && props.value) ? 
                         `${props.value.tdsCode} (${props.value.tdsAmount})` : tdsShown  ?
                         `${tdsShown.label} (${tdsShown.tax}%)`
                         :
                          null }
                    </div>
                </div>
                {
					changeTds ?
						<Modal
							onSave={() => {
								if (tdsMode === 'percentage') {
									if (!selectedTds) {
										showToast({
											type: 'error',
											value: 'Please enter some value'
										})
										return;
									}
                                    props.onSelect({
                                        "tdsSlab": selectedTds.tax,
                                        "tdsCode": selectedTds.label,
                                        "tdsDesc": selectedTds.des,
										"id": selectedTds.id,
										...(selectedTds && selectedTds.tdsMaster)?{"tdsMaster":selectedTds.tdsMaster}:{},
										...(selectedTds && selectedTds.type)?{"type":selectedTds.type}:{}
                                    })
									setTdsShown(selectedTds);
                                    setChangeTds(false);
								} else {
									let amount = Amount.current.value;
									let code = CODE.current.value;
									if (!amount) {
										showToast({
											type: 'error',
											message: "Please enter the amount"
										})
										return;
									}
									if(!code) {
										showToast({
											type: 'error',
											message: "Please enter the remarks"
										})
										return;
									}
                                    setChangeTds(false);
									showToast({
										type: 'success',
										message: "Field update successfully"
									})
								}
							}}
							style={{
								save: {
									padding: '12px 15px',
									width: '100%',
									textAlign: 'center',

								}
							}}
							show={true}
							title="Select Tds"
							des="Select Tds"
							close={() => {
                                setChangeTds(false);
							}}
							buttonName="Select Tds"
						>
							<LineHeader
								items={
									[
										{
											name: 'Select Percentage',
											active: tdsMode === 'percentage',
											click: () => {
                                                setTdsMode('percentage');
											}
										},

									]
								}
							/>
							<div style={{
								marginTop: 20
							}}/>
							{
								tdsMode === 'percentage' ?
									<SearchableSelect
										reset={()=>{setTds(allTds)}}
										disabled={props.disabled}
										label="Select Tds"
										placeholder="Select Tds"
										onChange={val => {
											if (val.length > 0) {
												let allItems = allTds.filter(item => {
													if (item.label.toLowerCase().includes(val.toLowerCase())) {
														return true
													}
													if (item.des.toLowerCase().includes(val.toLowerCase())) {
														return true;
													}
													if (String(item.tax).toLowerCase().includes(val.toLowerCase())) {
														return true
													}
													return false;
												})

                                                setTds(allItems);
											} else {
                                                setTds(allTds);
											}
										}}
			                  	        select={selectedTds => {
                                            setSelectedTds(selectedTds);
										}}
										value={selectedTds}
										items={tds}
										render={(item) => (
											<div style={{display:'flex', alignItems:'center', gap: 8}}>
												<input
													type="checkbox"
													readOnly
													checked={!!(selectedTds && (selectedTds.id === item.id))}
													style={{cursor:'pointer', flexShrink: 0}}
												/>
												<div>
													<p style={{fontSize:'12px'}}>{item.label}</p>
													{item.des && <p className="des">{item.des}</p>}
													{item.otherRate != null && <p className="des">Other Rate: {item.otherRate}%</p>}
													{item.individualHufRate != null && <p className="des">Individual Huf Rate: {item.individualHufRate}%</p>}
													{item.tax && item.otherRate == null && item.individualHufRate == null && <p className="des">{item.tax}%</p>}
												</div>
											</div>
										)}
									/>
									: 
									null
							}
						{selectedTds && !tdsAtLineItemAutomationV2 && !tdsAtLineItemAutomation &&
							<FunctionalInput
								ref={TDS_SLAB}
								title="Tds Slab"
								type="number"
								onChange={(e) => {
									setSelectedTds({...selectedTds,tax:Number(e.target.value)})
								}}
							/>
						}
						</Modal>
						: null
				}

        </>
    )
}

export default TdsLineItem;